import { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { createChannelValidation, sortingMethod } from '../../../_helpers';
import { toast } from 'react-toastify';

import loaderStyles from '../../../_elements/loader';
import { formLabel } from '../../../_elements/formLabel';
import formInput from '../../../_elements/formInput';
import { fetchWrapper } from '../../../_helpers';
import { connect } from 'react-redux';
import HomeLocationComponent from './HomeLocationComponent';
import Select from 'react-select';
import { VscLoading } from 'react-icons/vsc';
import styled from '@emotion/styled';
// import { Tags } from './_tag-data';

function CreateChannelModal({ show, handleClose, user, channelLatLong, updatePublicChannelsInMap }) {
	const [loading, setLoading] = useState(false);
	const [teamId, setTeamId] = useState(null);
	const [Tags, setTags] = useState([]);
	const [currentMarker, setCurrentMarker] = useState(null);

	const userTeamList = user.teamList
		.filter((team) => team.team && ['owner', 'teamManager'].includes(team.role))
		.map((team) => ({
			label: team.team.name,
			value: team.team.id || team.team._id,
		}));

	const handleSelect = (selected) => {
		setTeamId(selected.value);
	};
	const { register, watch, handleSubmit, setValue, getValues, errors } = useForm({
		mode: 'onBlur',
		resolver: yupResolver(createChannelValidation),
	});

	const onSubmit = async (data) => {
		if (data.title && data.subTitle) {
			setLoading(true);
			let tempData = data;
			tempData.type = 'public';
			tempData.team = teamId;
			try {
				// console.log(tempData, 'tempData');
				await fetchWrapper.post(`chatrooms`, tempData);

				// Create channel is handled in TeamList > by socket
				handleClose();
				setTimeout(() => {
					updatePublicChannelsInMap();
				});
				toast.success('Channel created successfully');
			} catch (e) {
				toast.error(e.message);
			}
			setLoading(false);
		}
	};
	useEffect(() => {
		const getCategories = async () => {
			try {
				const response = await fetchWrapper.get('pins');
				setTags(response.results.sort(sortingMethod));
			} catch (err) {
				console.log(err);
			}
		};
		getCategories();
	}, []);
	return (
		<Modal show={show} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title className="modal-headers">Create A Channel</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{loading && (
					<div css={loaderStyles}>
						<img src="/images/loading.gif" alt="loader" />
					</div>
				)}

				<Form.Group controlId="formBasicTitle">
					<Form.Label css={formLabel}>Team</Form.Label>
					<Select name="team" options={userTeamList} onChange={handleSelect} />
				</Form.Group>

				<Form.Group controlId="formBasicTitle">
					<Form.Label css={formLabel}>Channel Name</Form.Label>
					<Form.Control
						css={formInput}
						type="text"
						isInvalid={errors.title}
						placeholder="Enter Channel name"
						name="title"
						ref={register}
					/>
					<Form.Text className="text-danger">{errors.title?.message}</Form.Text>
				</Form.Group>
				<Form.Group controlId="formBasicSubTitle">
					<Form.Label css={formLabel}>Description</Form.Label>
					<Form.Control
						css={formInput}
						type="text"
						isInvalid={errors.subTitle}
						placeholder="What is your channel about"
						name="subTitle"
						ref={register}
					/>
					<Form.Text className="text-danger">{errors.subTitle?.message}</Form.Text>
				</Form.Group>
				<Form.Group controlId="formBasicTag">
					<Form.Label css={formLabel}>Category</Form.Label>
					<CategoryContainer>
						{Tags.map((tag) => (
							<Form.Check
								key={tag._id}
								defaultChecked={tag.default}
								type="radio"
								name="normalPinCategory"
								className="d-flex align-items-center mb-3"
								value={tag._id}
								label={
									<span>
										<img
											src={tag.pin}
											alt={tag.name}
											width="50"
											height="50"
											style={{ objectFit: 'contain', marginRight: '1rem' }}
										/>
										{tag.name}
									</span>
								}
								ref={register}
								id={tag._id}
								onClick={() => setCurrentMarker(tag.pin)}
							/>
						))}
					</CategoryContainer>
				</Form.Group>

				<HomeLocationComponent
					formLabel={formLabel}
					watch={watch}
					register={register}
					getValues={getValues}
					setValue={setValue}
					errors={errors}
					location={channelLatLong}
					currentMarker={currentMarker}
				/>
			</Modal.Body>
			<Modal.Footer className="d-flex justify-content-between align-items-center">
				<Button variant="secondary" onClick={handleClose}>
					Close
				</Button>
				<Button variant="primary" onClick={handleSubmit(onSubmit)} disabled={loading}>
					{loading ? <VscLoading className="spin" /> : 'Create Channel'}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}

const mapStateToProps = (state) => ({
	user: state.user.user,
});
export default connect(mapStateToProps, {})(CreateChannelModal);

const CategoryContainer = styled.div`
	max-height: 350px;
	overflow-y: auto;
`;
